// Lazy chunks (route pages, the trace diagram, d3, lottie, locales…) are requested
// relative to the public path, which is baked in as '/' at build time. Production
// HTML loads the bundles from cdn.tonscan.org, and a chunk asked from the site
// origin instead goes through the front cache, which can answer with the cached
// HTML of an unrelated page (this is how the trace diagram vanished). So chunks
// follow the origin the application bundle itself was loaded from.
//
// Must be evaluated before anything that may import() a chunk, hence the
// side-effect import at the very top of app.js.
const ownScript = document.currentScript
    || Array.from(document.scripts).find(script => /\/application\.[^/]*\.js(\?|$)/.test(script.src));

if (ownScript?.src) {
    try {
        // eslint-disable-next-line camelcase, no-undef, no-global-assign
        __webpack_public_path__ = new URL('./', ownScript.src).href;
    } catch {
        // Keep the build-time path.
    }
}
